<div class="container">
  <span class="tooltip-pointer-wrapper">
    <span class="tooltip-pointer"></span>
  </span>

  <div class="title">
    {{ basisDetails.code
    }}{{
      basisDetails.briefDescription ? ' ● ' + basisDetails.briefDescription : ''
    }}
  </div>

  <div class="group" *ngIf="basisDetails.shipmentBasisName">
    <span class="label">Наименование базиса</span>
    <span class="value">
      {{ basisDetails.shipmentBasisName }}
    </span>
  </div>

  <div
    class="group"
    *ngIf="basisDetails.forecastDate && basisDetails.forecastTrend"
  >
    <span class="label">Прогноз</span>
    <span class="value">
      на: {{ basisDetails.forecastDate | date: 'dd.MM.yyyy' }},
      <span class="trend-color trend-color--{{ basisDetails.forecastTrend }}">
        {{ forecastDescription }}
      </span>
    </span>
  </div>

  <div
    class="group"
    *ngIf="basisDetails.manufacturers.length <= maxAmountToShow"
  >
    <span class="label">Производитель</span>
    <span class="value" *ngFor="let manufacturer of basisDetails.manufacturers">
      {{ manufacturer }}
    </span>
    <span class="value" *ngIf="!basisDetails.manufacturers.length"
      >Неизвестно</span
    >
  </div>

  <div class="group" *ngIf="basisDetails.stations.length <= maxAmountToShow">
    <span class="label">Станция отгрузки</span>
    <span class="value" *ngFor="let station of stations">
      {{ station.name }}
    </span>
    <span class="value" *ngIf="!basisDetails.stations.length">Неизвестно</span>
  </div>

  <div class="group" *ngIf="pricingPoints.length > 0">
    <span class="label">Точка ценообразования</span>
    <span class="value" *ngFor="let pricingPoint of pricingPoints">
      {{ pricingPoint.name }}
    </span>
  </div>

  <div class="group" *ngIf="basisDetails.instrumentCode">
    <span class="label">Код инструмента</span>
    <span class="value">
      {{ basisDetails.instrumentCode }}
    </span>
  </div>

  <div class="group" *ngIf="basisDetails.instrumentName">
    <span class="label">Название инструмента</span>
    <span class="value">
      {{ basisDetails.instrumentName }}
    </span>
  </div>
</div>
